import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CalendarClock, AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtBRL = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

// Quadro: Despesas Fixas vencidas + a vencer nos próximos 7 dias
export const ExpenseDueAlertsWidget = ({ colors, isLight }) => {
  const [data, setData] = useState({ overdue: { count: 0, total: 0, items: [] }, due_soon: { count: 0, total: 0, items: [] } });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/financial/expenses/due-alerts?days=7`, { withCredentials: true })
      .then((r) => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const overdue = data.overdue || { count: 0, total: 0, items: [] };
  const dueSoon = data.due_soon || { count: 0, total: 0, items: [] };
  const rows = [
    ...overdue.items.map((i) => ({ ...i, kind: 'overdue' })),
    ...dueSoon.items.map((i) => ({ ...i, kind: 'soon' })),
  ];

  return (
    <div className="rounded-md p-5" style={{ background: colors.card, border: `1px solid ${colors.border}` }} data-testid="expense-due-alerts-widget">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-amber-400">Despesas Fixas</p>
          <h3 className="text-lg font-bold mt-0.5" style={{ color: isLight ? '#0F172A' : '#FFFFFF' }}>Vencimentos Próximos</h3>
        </div>
        <div className="p-2 rounded" style={{ background: 'rgba(245, 158, 11, 0.15)' }}>
          <CalendarClock size={18} className="text-amber-400" />
        </div>
      </div>

      <div className="flex items-end gap-6 mb-4">
        <div>
          <p className="text-[10px] uppercase tracking-widest font-bold" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>Vencidas</p>
          <p className="text-3xl font-black text-red-500 tabular-nums" data-testid="due-overdue-total">{fmtBRL(overdue.total)}</p>
          <p className="text-[10px]" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>{overdue.count} conta(s)</p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-widest font-bold" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>A vencer (7 dias)</p>
          <p className="text-3xl font-black text-amber-500 tabular-nums" data-testid="due-soon-total">{fmtBRL(dueSoon.total)}</p>
          <p className="text-[10px]" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>{dueSoon.count} conta(s)</p>
        </div>
      </div>

      {loading ? (
        <p className="text-xs py-4 text-center" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>Carregando...</p>
      ) : rows.length === 0 ? (
        <p className="text-xs py-4 text-center text-emerald-500 font-medium" data-testid="due-empty">✓ Nenhuma despesa vencida ou a vencer nos próximos 7 dias</p>
      ) : (
        <ol className="space-y-1.5" data-testid="due-alerts-list">
          {rows.slice(0, 6).map((it, i) => (
            <li key={it.id || i} className="flex items-center gap-2 py-1.5 border-b last:border-0" style={{ borderColor: colors.border }}>
              {it.kind === 'overdue'
                ? <AlertTriangle size={14} className="text-red-400 shrink-0" />
                : <CalendarClock size={14} className="text-amber-400 shrink-0" />}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate" style={{ color: isLight ? '#0F172A' : '#F1F5F9' }}>{it.description || '—'}</p>
                <p className={`text-[10px] font-bold ${it.kind === 'overdue' ? 'text-red-400' : 'text-amber-500'}`}>
                  {it.category}{' · '}
                  {it.kind === 'overdue'
                    ? `${it.days_overdue} dias vencida`
                    : (it.days_until_due === 0 ? 'vence hoje' : `vence em ${it.days_until_due} dia(s)`)}
                </p>
              </div>
              <span className={`text-sm font-bold font-mono shrink-0 ${it.kind === 'overdue' ? 'text-red-500' : 'text-amber-500'}`}>{fmtBRL(it.amount)}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
